// extracted by mini-css-extract-plugin
export default {"root":"ToggleButton_root__g6b94","open":"ToggleButton_open__9uhFN"};